import React from 'react';
export const BeforeAfterSection = () => {
  return <div className="my-8" data-id="element-328">
      <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-329">
        Reakcja Otoczenia
      </h3>
      <p className="text-lg mb-4" data-id="element-330">
        Najbardziej wzruszający był komentarz męża:
      </p>
      <blockquote className="border-l-4 border-[#3885B2] pl-4 italic text-lg mb-6" data-id="element-331">
        "Powiedział mi: 'Wróciła mi żona, którą poślubiłem.' Nie chodziło mu
        tylko o wygląd. Wróciła mu kobieta pełna energii, ochoty na życie,
        gotowa na nowe przygody."
      </blockquote>
      <p className="text-lg mb-4" data-id="element-332">
        Koledzy z pracy pytali o sekret. Przyjaciel rodziny, lekarz, chciał
        wiedzieć, co robi.
      </p>
      <p className="text-lg mb-6" data-id="element-333">
        "Nagle stałam się dowodem na to, że menopauza nie musi oznaczać końca
        dobrego samopoczucia."
      </p>
      <div className="bg-gray-50 p-6 rounded-lg" data-id="element-334">
        <h3 className="text-xl font-bold text-[#3885B2] mb-4" data-id="element-335">
          Wizyta Kontrolna u Lekarza
        </h3>
        <p className="text-lg mb-4" data-id="element-336">
          Po trzech miesiącach Ewa wróciła do tego samego lekarza, który ją
          zbył.
        </p>
        <p className="text-lg mb-4" data-id="element-337">
          "Jego mina była bezcenna," śmieje się Ewa. "Ciśnienie spadło, markery
          zapalenia w normie, cholesterol poprawił się. Zapytał, co robię. Gdy
          mu powiedziałam, pokręcił głową i stwierdził: 'Cokolwiek pani robi,
          niech pani nie przestaje.'"
        </p>
        <p className="text-lg" data-id="element-338">
          "Nie powiedział wprost, że się mylił. Ale ja wiedziałam, że miałam
          rację, nie szukając pomocy gdzie indziej."
        </p>
      </div>
    </div>;
};